import React, { Component } from "react";
export default class MemoryDelayedRec extends Component {
  render() {
    var {
      delayed_re_question_1_status,
      delayed_re_question_2_status,
      delayed_re_question_3_status,
      delayed_re_question_4_status,
      delayed_re_question_5_status,
      delayed_re_question_6_status,
      delayed_re_question_7_status,
      delayed_re_question_8_status,
      delayed_congniation_total_score,
    } = this.props.data;
    return (
      <div className="row border border-dark">
        <div className="col-lg-12">
          <hr />
          <ul style={{ paddingLeft: 20, fontSize: 19 }}>
            <li style={{ listStyle: "square" }}>
              Administration:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  This test should only be done if the person failed to recall
                  one or more items. If all the items were recalled, skip the
                  test and score 4.
                </li>
                <li style={{ listStyle: "circle" }}>
                  True and False questions regarding the story passage from
                  beginning of ECAS. If they patient responds “don’t know” to
                  any question, ask the patient to provide a best guess.
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Scoring:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Score 1 point for each correct answer; correct answers are
                  marked in bold in this section.
                </li>
                <li style={{ listStyle: "circle" }}>
                  If the person gives a “don’t know” answer ask them to make a
                  guess on True or False and score accordingly.
                </li>
                <li style={{ listStyle: "circle" }}>
                  Use the conversion table provided in ECAS to derive final
                  scoring for recognition section.
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Otherwise, say:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  “Let’s see if you can remember anything more about that story.
                  I will ask you some questions, please tell me if they are true
                  or false”.
                </li>
              </ul>
            </li>
          </ul>
          <hr />
          <table
            border="1"
            style={{
              border: "1px solid #000",
              borderCollapse: "collapse",
            }}
            cellPadding={5}
            className="w-100 p-4 mb-4"
          >
            <thead>
              <tr>
                <th>Question</th>
                <th style={{ width: 70 }}>True</th>
                <th style={{ width: 70 }}>False</th>
                <th style={{ width: 132 }}>Correct Answer</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  Was the story about an event that occurred last Saturday?
                </td>
                <td style={{ width: 50 }}>
                  <button
                    className={
                      delayed_re_question_1_status == "true"
                        ? "button active"
                        : "button"
                    }
                    style={{
                      marginLeft: 15,
                      fontSize: 19,
                    }}
                  >
                    T
                  </button>
                </td>
                <td style={{ width: 50 }}>
                  <button
                    className={
                      delayed_re_question_1_status == "false"
                        ? "button active"
                        : "button"
                    }
                    style={{
                      marginLeft: 15,
                      fontSize: 19,
                    }}
                  >
                    F
                  </button>
                </td>
                <td
                  style={{
                    width: 50,
                    fontSize: 17,
                    textAlign: "center",
                  }}
                >
                  F
                </td>
              </tr>
              <tr>
                <td>Was the event the park cleanup?</td>
                <td style={{ width: 50 }}>
                  <button
                    className={
                      delayed_re_question_2_status == "true"
                        ? "button active"
                        : "button"
                    }
                    style={{
                      marginLeft: 15,
                      fontSize: 19,
                    }}
                  >
                    T
                  </button>
                </td>
                <td style={{ width: 50 }}>
                  <button
                    className={
                      delayed_re_question_2_status == "false"
                        ? "button active"
                        : "button"
                    }
                    style={{
                      marginLeft: 15,
                      fontSize: 19,
                    }}
                  >
                    F
                  </button>
                </td>
                <td
                  style={{
                    width: 50,
                    fontSize: 17,
                    textAlign: "center",
                  }}
                >
                  T
                </td>
              </tr>
              <tr>
                <td>Did this take place in Marigold Woods?</td>
                <td style={{ width: 50 }}>
                  <button
                    className={
                      delayed_re_question_3_status == "true"
                        ? "button active"
                        : "button"
                    }
                    style={{
                      marginLeft: 15,
                      fontSize: 19,
                    }}
                  >
                    T
                  </button>
                </td>
                <td style={{ width: 50 }}>
                  <button
                    className={
                      delayed_re_question_3_status == "false"
                        ? "button active"
                        : "button"
                    }
                    style={{
                      marginLeft: 15,
                      fontSize: 19,
                    }}
                  >
                    F
                  </button>
                </td>
                <td
                  style={{
                    width: 50,
                    fontSize: 17,
                    textAlign: "center",
                  }}
                >
                  T
                </td>
              </tr>
              <tr>
                <td>Did they remove old soda cans and candy wrappers?</td>
                <td style={{ width: 50 }}>
                  <button
                    className={
                      delayed_re_question_4_status == "true"
                        ? "button active"
                        : "button"
                    }
                    style={{
                      marginLeft: 15,
                      fontSize: 19,
                    }}
                  >
                    T
                  </button>
                </td>
                <td style={{ width: 50 }}>
                  <button
                    className={
                      delayed_re_question_4_status == "false"
                        ? "button active"
                        : "button"
                    }
                    style={{
                      marginLeft: 15,
                      fontSize: 19,
                    }}
                  >
                    F
                  </button>
                </td>
                <td
                  style={{
                    width: 50,
                    fontSize: 17,
                    textAlign: "center",
                  }}
                >
                  F
                </td>
              </tr>
              <tr>
                <td>Was the man in the story called Mr. Webber?</td>
                <td style={{ width: 50 }}>
                  <button
                    className={
                      delayed_re_question_5_status == "true"
                        ? "button active"
                        : "button"
                    }
                    style={{
                      marginLeft: 15,
                      fontSize: 19,
                    }}
                  >
                    T
                  </button>
                </td>
                <td style={{ width: 50 }}>
                  <button
                    className={
                      delayed_re_question_5_status == "false"
                        ? "button active"
                        : "button"
                    }
                    style={{
                      marginLeft: 15,
                      fontSize: 19,
                    }}
                  >
                    F
                  </button>
                </td>
                <td
                  style={{
                    width: 50,
                    fontSize: 17,
                    textAlign: "center",
                  }}
                >
                  T
                </td>
              </tr>
              <tr>
                <td>Was his first name ‘Thomas’?</td>
                <td style={{ width: 50 }}>
                  <button
                    className={
                      delayed_re_question_6_status == "true"
                        ? "button active"
                        : "button"
                    }
                    style={{
                      marginLeft: 15,
                      fontSize: 19,
                    }}
                  >
                    T
                  </button>
                </td>
                <td style={{ width: 50 }}>
                  <button
                    className={
                      delayed_re_question_6_status == "false"
                        ? "button active"
                        : "button"
                    }
                    style={{
                      marginLeft: 15,
                      fontSize: 19,
                    }}
                  >
                    F
                  </button>
                </td>
                <td
                  style={{
                    width: 50,
                    fontSize: 17,
                    textAlign: "center",
                  }}
                >
                  F
                </td>
              </tr>
              <tr>
                <td>Was he from the local government? </td>
                <td style={{ width: 50 }}>
                  <button
                    className={
                      delayed_re_question_7_status == "true"
                        ? "button active"
                        : "button"
                    }
                    style={{
                      marginLeft: 15,
                      fontSize: 19,
                    }}
                  >
                    T
                  </button>
                </td>
                <td style={{ width: 50 }}>
                  <button
                    className={
                      delayed_re_question_7_status == "false"
                        ? "button active"
                        : "button"
                    }
                    style={{
                      marginLeft: 15,
                      fontSize: 19,
                    }}
                  >
                    F
                  </button>
                </td>
                <td
                  style={{
                    width: 50,
                    fontSize: 17,
                    textAlign: "center",
                  }}
                >
                  F
                </td>
              </tr>
              <tr>
                <td>
                  Was he especially proud of the children for coming along?
                </td>
                <td style={{ width: 50 }}>
                  <button
                    className={
                      delayed_re_question_8_status == "true"
                        ? "button active"
                        : "button"
                    }
                    style={{
                      marginLeft: 15,
                      fontSize: 19,
                    }}
                  >
                    T
                  </button>
                </td>
                <td style={{ width: 50 }}>
                  <button
                    className={
                      delayed_re_question_8_status == "false"
                        ? "button active"
                        : "button"
                    }
                    style={{
                      marginLeft: 15,
                      fontSize: 19,
                    }}
                  >
                    F
                  </button>
                </td>
                <td
                  style={{
                    width: 50,
                    fontSize: 17,
                    textAlign: "center",
                  }}
                >
                  T
                </td>
              </tr>
            </tbody>
          </table>
          <div className="row">
            <div className="col-lg-4 ml-auto">
              <table
                cellPadding={4}
                className="table-black w-100 border border-dark text-centermb-3"
              >
                <tbody>
                  <tr>
                    <th
                      className="light-grey"
                      colSpan="2"
                      style={{
                        border: "1px solid #000",
                      }}
                    >
                      Recognition to recognition score table
                    </th>
                  </tr>
                  <tr>
                    <th
                      style={{
                        border: "1px solid #000",
                      }}
                    >
                      Number of correct answers
                    </th>
                    <th
                      style={{
                        border: "1px solid #000",
                      }}
                    >
                      Score
                    </th>
                  </tr>
                  <tr>
                    <td>0-4</td>
                    <td>0</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>1</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>2</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>3</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>4</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-lg-6">
            <br />
            <span className="fs-19">Score (0-4) </span>
            <input
              type="number"
              className="ecas-input-field"
              placeholder="Score"
              name="delayed_congniation_total_score"
              value={delayed_congniation_total_score}
            />
          </div>
        </div>
      </div>
    );
  }
}
